<script lang="ts">
  import { Icon } from '@shared/ui/icon';
  import { getFullYear } from '@shared/utils';

  import type { ArtistType } from '@entities/artist';

  export let fields: ArtistType['fields'] = [];
  export let styles: ArtistType['styles'] = [];
  export let socialProfiles: ArtistType['socialProfiles'] = [];
  export let countries: string[];
  export let dateOfBirth: ArtistType['dateOfBirth'];
  export let dateOfDeath: ArtistType['dateOfDeath'];

  $: list = [
    {
      name: 'Styles',
      value: styles.length ? styles : null,
    },
    {
      name: 'Medium',
      value: fields.length ? fields : null,
    },
  ];

  const socialTypes = ['instagram', 'x', 'facebook', 'linkedin'];

  const getSocials = (socials: ArtistType['socialProfiles']) =>
    socials.filter((social) => socialTypes.includes(social.type));

  $: preparedSocials = socialProfiles ? getSocials(socialProfiles) : [];
  $: site = socialProfiles.find((social) => social.type === 'site');
</script>

{#if dateOfBirth}
  <div class="mb-5 flex flex-col gap-2 md:flex-row md:gap-0">
    <p class="flex-0.2 text-dark-700 text-base font-normal">Year of birth:</p>

    <span class="flex-0.7 flex flex-wrap gap-x-1.5 text-base font-medium">
      {getFullYear(dateOfBirth)}
    </span>
  </div>
{/if}

{#if dateOfDeath}
  <div class="mb-5 flex flex-col gap-2 md:flex-row md:gap-0">
    <p class="flex-0.2 text-dark-700 text-base font-normal">Year of death:</p>

    <span class="flex-0.7 flex flex-wrap gap-x-1.5 text-base font-medium">
      {getFullYear(dateOfDeath)}
    </span>
  </div>
{/if}

{#if countries && countries.length}
  <div class="mb-5 flex flex-col gap-2 md:flex-row md:gap-0">
    <p class="flex-0.2 text-dark-700 text-base font-normal">Country:</p>

    <ul class="flex-0.7 flex flex-wrap gap-x-1.5">
      {#each countries as country, index}
        <li class="hover:text-dark-800 text-base font-medium transition-colors">
          {country}
          {index < countries.length - 1 ? ',' : ''}
        </li>
      {/each}
    </ul>
  </div>
{/if}

{#each list as item}
  {#if item.value}
    <div class="mb-5 flex flex-col gap-2 last:mb-0 md:flex-row md:gap-0">
      <p class="flex-0.2 text-dark-700 text-base font-normal">{item.name}:</p>

      <ul class="flex-0.7 flex flex-wrap gap-x-1.5">
        {#each item.value as field, index}
          <li class="hover:text-dark-800 text-base font-medium transition-colors">
            <a href="/artworks/{item.name.toLocaleLowerCase()}-{field.slug}/">
              {field.name}
            </a>
            {index < item.value.length - 1 ? ',' : ''}
          </li>
        {/each}
      </ul>
    </div>
  {/if}
{/each}

{#if site}
  <div class="mb-5 flex flex-col gap-2 last:mb-0 md:flex-row md:items-center md:gap-0">
    <p class="flex-0.2 text-dark-700 text-base font-normal">Site:</p>

    <div class="flex-0.7 flex items-center gap-3">
      <Icon name="website" classes="mt-0.5" />

      <a
        href="{site.value}"
        target="_blank"
        class="underline-hover underline-static text-base font-medium transition-colors"
        rel="nofollow"
      >
        {site.value}
      </a>
    </div>
  </div>
{/if}

{#if preparedSocials.length}
  <div class="flex flex-col gap-2 last:mb-0 md:flex-row md:items-center md:gap-0">
    <p class="flex-0.2 text-dark-700 text-base font-normal">Socials:</p>

    <ul class="flex-0.7 flex flex-wrap gap-8">
      {#each preparedSocials as social}
        <li>
          <a
            href="{social.value}"
            target="_blank"
            class="hover:text-default-500 font-medium transition-colors"
            rel="nofollow"
          >
            <Icon name="{social.type}" classes="w-5 h-5" />
          </a>
        </li>
      {/each}
    </ul>
  </div>
{/if}
